import { render, staticRenderFns } from "./MessageDetailConfirm.vue?vue&type=template&id=460e8796&scoped=true"
import script from "./MessageDetailConfirm.vue?vue&type=script&lang=ts"
export * from "./MessageDetailConfirm.vue?vue&type=script&lang=ts"
import style0 from "./MessageDetailConfirm.vue?vue&type=style&index=0&id=460e8796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e8796",
  null
  
)

export default component.exports